export default __webpack_public_path__ + "static/media/352.6205ab2f.png";